var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLdlExperienceLocationRev0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4592",
    "data-name": "Ret\\xE2ngulo 4592",
    width: 53.268,
    height: 75.059,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9441",
    "data-name": "Grupo 9441",
    transform: "translate(-261 -3687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeti\\xE7\\xE3o_de_grade_16",
    "data-name": "Repeti\\xE7\\xE3o de grade 16",
    transform: "translate(261 3687)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-261 -3687)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4580",
    "data-name": "Ret\\xE2ngulo 4580",
    width: 99,
    height: 99,
    rx: 16,
    transform: "translate(261 3687)",
    fill: "#3b3b3b",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9240",
    "data-name": "Grupo 9240",
    transform: "translate(283.867 3700.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9239",
    "data-name": "Grupo 9239",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5268",
    "data-name": "Caminho 5268",
    d: "M26.685,69.568c-1.384-1.446-2.695-2.775-3.962-4.145A132.187,132.187,0,0,1,6.354,44.34,45.155,45.155,0,0,1,.674,31.584,23.969,23.969,0,0,1,3.407,13.706,25.778,25.778,0,0,1,22.428.358,26.629,26.629,0,0,1,52.674,20.817a25.019,25.019,0,0,1-1.99,16.314A87.2,87.2,0,0,1,40.1,54.138,165.981,165.981,0,0,1,27.312,68.851c-.189.194-.357.407-.627.716M26.6,66.061c.314-.3.545-.491.735-.713,3.634-4.242,7.372-8.4,10.866-12.755a76.742,76.742,0,0,0,10.093-16A23.562,23.562,0,0,0,50.5,22.262C48.223,9.55,35.746.574,22.976,2.711A23.569,23.569,0,0,0,5,15.88,21.256,21.256,0,0,0,3.6,32.97,50.946,50.946,0,0,0,8.2,42.6,124.625,124.625,0,0,0,21.238,60.1c1.741,2,3.549,3.95,5.361,5.961",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5269",
    "data-name": "Caminho 5269",
    d: "M64.527,311.562l1.424,1.859c-.219.208-.415.389-.6.575-1.769,1.733-1.823,3.788.071,5.371a11.9,11.9,0,0,0,3.66,2.133,20.08,20.08,0,0,0,15.98-.827,7.8,7.8,0,0,0,2.1-1.6,3.219,3.219,0,0,0,.016-4.807c-.261-.29-.56-.546-.868-.844l1.4-1.828c2.714,1.754,3.953,5.257,1.94,8.211a10.089,10.089,0,0,1-4.2,3.392,22.071,22.071,0,0,1-11.014,1.87,19.059,19.059,0,0,1-8.4-2.294,12.225,12.225,0,0,1-2.263-1.639c-3.133-2.93-2.821-7.024.756-9.576",
    transform: "translate(-49.456 -250.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5270",
    "data-name": "Caminho 5270",
    d: "M75.908,61.407A14.527,14.527,0,1,1,61.391,75.971,14.554,14.554,0,0,1,75.908,61.407m.033,26.982a12.457,12.457,0,1,0-12.449-12.44A12.465,12.465,0,0,0,75.94,88.389",
    transform: "translate(-49.275 -49.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4589",
    "data-name": "Ret\\xE2ngulo 4589",
    width: 2.309,
    height: 2.341,
    transform: "translate(25.513 47.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4590",
    "data-name": "Ret\\xE2ngulo 4590",
    width: 2.3,
    height: 2.352,
    transform: "translate(25.517 52.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4591",
    "data-name": "Ret\\xE2ngulo 4591",
    width: 2.32,
    height: 2.338,
    transform: "translate(25.494 56.927)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLdlExperienceLocationRev0);
export default __webpack_public_path__ + "static/media/icon-ldl-experience-location-rev0.905e8b52e92b9453e69939d7d7a8cc50.svg";
export { ForwardRef as ReactComponent };